import { render, staticRenderFns } from "./myupload.vue?vue&type=template&id=b0a46e64&scoped=true"
import script from "./myupload.vue?vue&type=script&lang=js"
export * from "./myupload.vue?vue&type=script&lang=js"
import style0 from "./myupload.vue?vue&type=style&index=0&id=b0a46e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a46e64",
  null
  
)

export default component.exports